import { parseItems } from './parsers/items';
import { toError } from './parsers/error';
import { ContentType } from '../../constants/ContentType';
export function initItem(settings, http) {
  function getMulti(itemIds, options) {
    options = options || {};
    if (Array.isArray(itemIds)) {
      itemIds = itemIds.join(',');
    }
    const queryParams = {
      guid: itemIds,
      language: options.language,
      client: options.client
    };
    const headers = {
      ...options.headers,
      'Content-Type': ContentType.UrlEncoded
    };
    return http.get(`${settings.apiUrl}/multi_item`, queryParams, {
      withCredentials: true,
      headers
    }).then(response => parseItems(response, settings, options.thumbnails)).catch(toError);
  }
  return {
    get: getMulti
  };
}